const PERMISSION_KEY= "core:integration_log";
const PAGE_URL = {
    INTEGRATION_LOG_PAGE: "/admin/core/integration-log"
}

export {PERMISSION_KEY, PAGE_URL}

